import api from '../api'; // your configured axios instance
import { API_URL } from '../config';

// GET all documents
export const getAllDocuments = async () => {
  const response = await api.get('/documents/');
  return response.data;
};

// GET documents for authenticated user
export const getMyDocuments = async () => {
  try {
    const response = await api.get('/documents/me');
    console.log('My documents response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching my documents:', error);
    throw error;
  }
};
// GET document by ID
export const getDocumentById = async (id) => {
  const response = await api.get(`/documents/${id}`);
  return response.data;
};

// POST new document
export const createDocument = async (formData) => {
  const response = await api.post('/documents/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

// PUT update document
export const updateDocument = async (id, formData) => {
  const response = await api.put(`/documents/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

// DELETE document
export const deleteDocument = async (id) => {
  const response = await api.delete(`/documents/${id}`);
  return response.data;
};